import React, { Component } from 'react';
import axios from 'axios';
import { Select } from 'antd';
import { authService } from '../../services/authService';
import { API_BASE_URL } from '../../config/api';

// ICD-10 picker: searches /connect/diagnoses (same table Order Entry uses) as
// the user types. value/onChange carry [{ code, description }]. A code that
// the search does not know can still be entered as typed (Enter): the lab
// may not dictate the physician's diagnosis, so nothing is rejected.

class IcdSelect extends Component {
  state = { options: [], fetching: false };

  componentWillUnmount() { clearTimeout(this.timer); }

  onSearch = (q) => {
    clearTimeout(this.timer);
    const text = q.trim();
    if (!text) { this.setState({ options: [] }); return; }
    this.timer = setTimeout(() => this.search(text), 300);
  }

  search = async (q) => {
    const token = await authService.ensureValidToken();
    if (!token) return;
    this.setState({ fetching: true });
    axios({
      method: 'GET',
      url: `${API_BASE_URL}/connect/diagnoses`,
      params: { q, limit: 10 },
      headers: { Authorization: `Bearer ${token}` },
    }).then(res => {
      this.setState({
        options: (res.data.items || []).map(d => ({ value: d.code, label: `${d.code} — ${d.description}` })),
        fetching: false,
      });
    }).catch(err => {
      console.log(err);
      this.setState({ fetching: false });
    });
  }

  render() {
    const { value = [], onChange, placeholder } = this.props;
    return (
      <Select
        mode="tags"
        size="small"
        popupClassName="billing-errors-dropdown"
        showSearch
        labelInValue
        filterOption={false}
        notFoundContent={null}
        loading={this.state.fetching}
        placeholder={placeholder || 'Type a code or description'}
        value={value.map(v => ({ value: v.code, label: `${v.code}${v.description ? ` — ${v.description}` : ''}` }))}
        options={this.state.options}
        onSearch={this.onSearch}
        onChange={(vals) => {
          onChange(vals.map(v => {
            const code = String(v.value || '').replace(/\s+/g, '').toUpperCase();
            const label = String(v.label || '');
            return { code, description: label.includes(' — ') ? label.split(' — ').slice(1).join(' — ') : '' };
          }).filter(v => v.code));
          this.setState({ options: [] });
        }}
        style={{ width: '100%' }}
      />
    );
  }
}

export default IcdSelect;
